var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import './leadershipGrid.scss';
import LeadershipBio from './micro/leadershipBio';
var LeadershipGrid = function (_a) {
    var _b = _a.data, gridCards = _b.gridCards, horizontalBannerText = _b.horizontalBannerText, memoriumCard = _b.memoriumCard;
    var _c = useState(false), showBio = _c[0], setShowBio = _c[1];
    var _d = useState(null), cardBio = _d[0], setCardBio = _d[1];
    var gridRef = useRef(null);
    var navigate = useNavigate();
    var columns = window.visualViewport.width < 768
        ? 1
        : window.visualViewport.width < 1024
            ? 2
            : 3;
    var showBioHandler = function (id) {
        navigate("/leadership#" + id, { replace: true });
        setShowBio(true);
        if (columns === 1) {
            document.getElementsByTagName('nav')[0].style.visibility = 'hidden';
        }
    };
    var hideBioHandler = function () {
        setShowBio(false);
        navigate('/leadership', { replace: true });
        if (columns === 1) {
            document.getElementsByTagName('nav')[0].style.visibility = 'inherit';
        }
    };
    var openBio = function (event) {
        var _a;
        var biodata = JSON.parse((_a = event.currentTarget) === null || _a === void 0 ? void 0 : _a.dataset['leadershipcard']);
        setCardBio(biodata);
        showBioHandler(biodata.id);
    };
    var createTile = function (tileList) {
        var tiles = [];
        tileList.map(function (tileData) {
            var element = null;
            if (tileData.type == 'image_card') {
                element = (_jsxs("div", __assign({ className: "leadershipGrid-tile", id: tileData.id, onClick: openBio, "data-leadershipcard": JSON.stringify(tileData) }, { children: [_jsxs("div", __assign({ className: "leadershipGrid-tileWrapper" }, { children: [_jsx("img", { className: "leadershipGrid-image", src: tileData.hoverStateImgSrc, alt: tileData.hoverStateImgAlt }, void 0),
                                tileData.hoverStateText && (_jsx("div", __assign({ className: "leadershipGrid-hoverStateText" }, { children: parse(tileData.hoverStateText) }), void 0))] }), void 0),
                        _jsx("img", { className: "leadershipGrid-image", src: tileData.cardImgSrc, alt: tileData.cardImgAlt }, void 0),
                        _jsxs("div", __assign({ className: "leadershipGrid-textWrapper" }, { children: [_jsx("p", { children: tileData.name }, void 0),
                                _jsx("p", { children: tileData.title }, void 0)] }), void 0)] }), tileData.id));
            }
            else if (tileData.type == 'quote_card') {
                element = (_jsx("div", __assign({ className: "leadershipGrid-tile", id: "quote_card" }, { children: _jsxs("div", __assign({ className: "leadershipGrid-quote" }, { children: [_jsx("p", __assign({ className: "leadershipGrid-quote_headline" }, { children: tileData.headline }), void 0),
                            _jsx("p", __assign({ className: "leadershipGrid-quote_subHead" }, { children: tileData.subHead }), void 0)] }), void 0) }), "quote_card"));
            }
            tiles.push(element);
        });
        return tiles;
    };
    var tileElements = gridCards ? createTile(gridCards) : [];
    var renderList = function (tileElements) {
        var ulArray = [];
        for (var i = 0; i < tileElements.length; i += columns) {
            var index = i;
            var limit = index + columns;
            var liArray = [];
            while (index < limit) {
                var card = tileElements[index];
                if (card) {
                    liArray.push(card);
                }
                index++;
            }
            var ulItem = (_jsx("div", __assign({ className: "leadershipGrid-row" }, { children: liArray }), index));
            ulArray.push(ulItem);
            if (index == 6 ||
                (index < 6 && index === tileElements.length && horizontalBannerText)) {
                var horizontalBanner = (_jsx("div", __assign({ className: "leadershipGrid-horizontalBanner" }, { children: _jsx("p", { children: horizontalBannerText }, void 0) }), "horizontalBanner"));
                ulArray.push(horizontalBanner);
            }
        }
        return ulArray;
    };
    useEffect(function () {
        var urlIds = window.location.href.split('#');
        var id = urlIds ? urlIds[urlIds.length - 1] : null;
        if (gridRef.current !== null && id !== null) {
            var target = gridRef.current.getElementsByClassName('leadershipGrid-tile');
            for (var i = 0; i < target.length; i++) {
                var ele = target[i];
                if (ele.id == id) {
                    var biodata = ele === null || ele === void 0 ? void 0 : ele.dataset['leadershipcard'];
                    setCardBio(JSON.parse(biodata));
                    showBioHandler(id);
                    break;
                }
            }
        }
    }, []);
    return (_jsxs("div", __assign({ className: "leadershipGrid-section", ref: gridRef }, { children: [renderList(tileElements), memoriumCard && (_jsxs("div", __assign({ className: "leadershipGrid-row_memo" }, { children: [memoriumCard.textCard && (_jsxs("div", __assign({ className: "leadershipGrid-tile_memo" }, { children: [_jsx("img", { className: "leadershipGrid-image", src: memoriumCard.textCard.textCardImgSrc, alt: memoriumCard.textCard.textCardImgAlt }, void 0),
                            _jsxs("div", __assign({ className: "leadershipGrid-text_memo" }, { children: [_jsx("p", __assign({ className: "leadershipGrid-text_memo-eyeBrow" }, { children: memoriumCard.textCard.eyeBrow }), void 0),
                                    memoriumCard.textCard.headline && (_jsx("div", __assign({ className: "leadershipGrid-text_memo-headline" }, { children: parse(memoriumCard.textCard.headline) }), void 0))] }), void 0)] }), "memo-textCard")),
                    memoriumCard.imageCard && (_jsxs("div", __assign({ className: "leadershipGrid-tile_memo", id: memoriumCard.imageCard.id, onClick: openBio, "data-leadershipcard": JSON.stringify(memoriumCard.imageCard) }, { children: [_jsxs("div", __assign({ className: "leadershipGrid-tileWrapper" }, { children: [_jsx("img", { className: "leadershipGrid-image", src: memoriumCard.imageCard.hoverStateImgSrc, alt: memoriumCard.imageCard.hoverStateImgAlt }, void 0),
                                    memoriumCard.imageCard.hoverStateText && (_jsx("div", __assign({ className: "leadershipGrid-hoverStateText" }, { children: parse(memoriumCard.imageCard.hoverStateText) }), void 0))] }), void 0),
                            _jsx("img", { className: "leadershipGrid-image", src: memoriumCard.imageCard.cardImgSrc, alt: memoriumCard.imageCard.cardImgAlt }, void 0),
                            _jsxs("div", __assign({ className: "leadershipGrid-textWrapper" }, { children: [_jsx("p", { children: memoriumCard.imageCard.name }, void 0),
                                    _jsx("p", { children: memoriumCard.imageCard.title }, void 0)] }), void 0)] }), memoriumCard.imageCard.id))] }), void 0)),
            showBio && (_jsx(LeadershipBio, { data: cardBio, closeModal: hideBioHandler }, void 0))] }), void 0));
};
export default LeadershipGrid;
